const IMG = 'https://static.prod-images.emergentagent.com/jobs/6011386d-adfc-4415-9257-23eae86765a4/images';

export const themeCategories = [
  { id: 'all', label: 'All' },
  { id: 'classic', label: 'Klassisk' },
  { id: 'romantic', label: 'Romantisk' },
  { id: 'modern', label: 'Moderne' },
  { id: 'rustic', label: 'Rustikk' },
  { id: 'season', label: 'Sesong' },
  { id: 'destination', label: 'Destination' },
];

export const weddingThemes = [
  {
    id: 'timeless-ivory', name: 'Timeless Ivory', category: 'classic',
    description: 'Classic elegance with ivory, gold and timeless details. Perfect for the sophisticated couple who values tradition.',
    coverImage: `${IMG}/34a2493306f7b8c010bdc7340c12c122d4de32c4bdc8f9a0ef16f8f88fa7d883.jpeg`,
    colors: ['#F5F0E8', '#D4AF37', '#8B7355', '#2C2C2C', '#FFFFF8'],
    colorNames: ['Ivory', 'Gold', 'Taupe', 'Charcoal', 'Creamhvit'],
    fonts: { heading: 'Cormorant Garamond', body: 'Lora' },
    mood: 'Timeless, classic, elegant',
  },
  {
    id: 'editorial-luxury', name: 'Editorial Luxury', category: 'classic',
    description: 'Raffinert og dempet luksus med taupe-toner og gulldetaljer. For det moderne, stilbevisste paret.',
    coverImage: `${IMG}/bc6944563f4bcea9f98d6628471ad5505f5ed7aaf9666b4fcf6ede3f9c37201d.jpeg`,
    colors: ['#F7F5F2', '#B49A88', '#D4AF37', '#3A3530', '#FBFAF8'],
    colorNames: ['Off-white', 'Taupe', 'Gold', 'Dark brown', 'White'],
    fonts: { heading: 'Cormorant Garamond', body: 'Inter' },
    mood: 'Sofistikert, dempet, editorial',
  },
  {
    id: 'romantic-blush', name: 'Romantic Blush', category: 'romantic',
    description: 'Soft pink with rose gold details and delicate floral ornaments. Dreamy and romantic.',
    coverImage: `${IMG}/0a6b1eb6dcfd55afb448084989d937b9d1bd32fc1b153b43da82cf1af39a5019.jpeg`,
    colors: ['#F8E8E0', '#B76E79', '#E8C4B0', '#4A3540', '#FFF5F5'],
    colorNames: ['Blush', 'Rosé', 'Fersken', 'Plum', 'Light rosa'],
    fonts: { heading: 'Playfair Display', body: 'Lora' },
    mood: 'Romantic, soft, dreamy',
  },
  {
    id: 'italian-summer', name: 'Italian Summer', category: 'destination',
    description: 'Varme terrakotta-toner med oliven og gull. Inspirert av toskanske solnedganger og sitronlunder.',
    coverImage: `${IMG}/ae61f95d5ab525b2afaadfae6790b145516581731b7c3bff04548c0f27dde7e0.jpeg`,
    colors: ['#F5E6D0', '#C4723A', '#7A8B5C', '#D4AF37', '#FFF8EE'],
    colorNames: ['Sand', 'Terracotta', 'Oliven', 'Gold', 'Cream'],
    fonts: { heading: 'Cormorant Garamond', body: 'Source Serif Pro' },
    mood: 'Varm, solrik, middelhavs',
  },
  {
    id: 'french-chateau', name: 'French Ch\u00e2teau', category: 'destination',
    description: 'Elegant lavender with silver details and rococo-inspired ornaments. Palace romance from Provence.',
    coverImage: `${IMG}/e9a4171a885fb058bf16833491b0b5abd2f2030fd8f238b3843786f9d08e2afe.jpeg`,
    colors: ['#E8E0F0', '#9B8EC4', '#C0C0C0', '#3D3555', '#FAF8FF'],
    colorNames: ['Lavender', 'Purple', 'Silver', 'Dark purple', 'Ice blue'],
    fonts: { heading: 'Playfair Display', body: 'Lora' },
    mood: 'Romantisk, fransk, royal',
  },
  {
    id: 'tuscan-wedding', name: 'Tuscan Wedding', category: 'destination',
    description: 'Golden ocher with sage green and terracotta. Warm as a Tuscan vineyard at sunset.',
    coverImage: `${IMG}/730fa5a1f5ab0fac1dc68f136cfed34f9646c6e2f3d9c5d8fdd07b9c78c5ffe5.jpeg`,
    colors: ['#F0E2C8', '#C99B3B', '#7B8B5E', '#8B5E3C', '#FFF5E0'],
    colorNames: ['Ocher', 'Gold', 'Sage', 'Terracotta', 'Cream'],
    fonts: { heading: 'Cormorant Garamond', body: 'Source Serif Pro' },
    mood: 'Varm, rustikk, italiensk',
  },
  {
    id: 'scandinavian-minimal', name: 'Scandinavian Minimal', category: 'modern',
    description: 'Pure white with minimal gray lines. Nordic simplicity at its finest.',
    coverImage: `${IMG}/e844a5afc7acfeb02f7914a08c2d55888adc0bb657406b5b4a047cb3e783edd2.jpeg`,
    colors: ['#FFFFFF', '#E5E5E5', '#B0B0B0', '#333333', '#FAFAFA'],
    colorNames: ['White', 'Light gray', 'Gray', 'Dark gray', 'Snow white'],
    fonts: { heading: 'Inter', body: 'Inter' },
    mood: 'Minimalistisk, ren, nordisk',
  },
  {
    id: 'modern-monochrome', name: 'Modern Monochrome', category: 'modern',
    description: 'Dristig svart-hvitt med geometriske aksenter. For det modige, samtidskunst-inspirerte paret.',
    coverImage: `${IMG}/e6009a4738f56fc200cb226e01cf55e5644f39124c83689540e3a4bb259ab37d.jpeg`,
    colors: ['#1A1A1A', '#FFFFFF', '#666666', '#333333', '#F5F5F5'],
    colorNames: ['Black', 'White', 'Medium gray', 'Charcoal', 'Light'],
    fonts: { heading: 'Montserrat', body: 'Inter' },
    mood: 'Dristig, moderne, kontrastrik',
  },
  {
    id: 'black-tie', name: 'Black Tie', category: 'classic',
    description: 'Deep black with luxurious gold embossing. Art deco-inspired for the most formal celebration.',
    coverImage: `${IMG}/0eb6148585b8e8df604d6f777f050b3e2b39c5df6fd1e091c9addd11c8bea001.jpeg`,
    colors: ['#0D0D0D', '#D4AF37', '#8B7355', '#F5F0E8', '#1A1A1A'],
    colorNames: ['Black', 'Gold', 'Bronse', 'Ivory', 'Nattsvart'],
    fonts: { heading: 'Playfair Display', body: 'Cormorant Garamond' },
    mood: 'Formal, luxurious, art deco',
  },
  {
    id: 'champagne-pearl', name: 'Champagne & Pearl', category: 'classic',
    description: 'Champagne gold with pearl white accents. Subtle shine and timeless sophistication.',
    coverImage: `${IMG}/204a6560a097981ca6738607ecb1ccb283816f62faf607232f35923696b62694.jpeg`,
    colors: ['#F5EDE0', '#C9A96E', '#E8D5C0', '#4A4038', '#FFFFF5'],
    colorNames: ['Champagne', 'Gold', 'Pearl', 'Varm brun', 'Creamhvit'],
    fonts: { heading: 'Cormorant Garamond', body: 'Lora' },
    mood: 'Luxurious, warm, sophisticated',
  },
  {
    id: 'garden-romance', name: 'Garden Romance', category: 'romantic',
    description: 'Sage green with blush-pink watercolor flowers. Inspired by English rose gardens.',
    coverImage: `${IMG}/8601dd36a0ed86509f54733117048235e735095f603b1327d1a057291c7af7db.jpeg`,
    colors: ['#E8F0E8', '#A8C0A0', '#E8B0B0', '#3A4838', '#F8FAF8'],
    colorNames: ['Light green', 'Sage', 'Blush', 'Forest green', 'Mint cream'],
    fonts: { heading: 'Playfair Display', body: 'Lora' },
    mood: 'Romantisk, botanisk, hagebryllup',
  },
  {
    id: 'wildflower', name: 'Wildflower', category: 'rustic',
    description: 'Colorful wildflowers against cream-white background. Casual, joyful and natural.',
    coverImage: `${IMG}/9ca69f08e50aba623f05fd1f6dd25c534ea5026e5d64d09b81427a735156fb62.jpeg`,
    colors: ['#FFF8F0', '#E07050', '#6B8F5B', '#F0C040', '#F5E8D8'],
    colorNames: ['Cream', 'Poppy', 'Grass green', 'Sunflower', 'Sand'],
    fonts: { heading: 'Playfair Display', body: 'Source Serif Pro' },
    mood: 'Uformell, fargerik, naturlig',
  },
  {
    id: 'coastal-wedding', name: 'Coastal Wedding', category: 'destination',
    description: 'Ocean blue with sand-gold details. Fresh sea breeze and gentle waves.',
    coverImage: `${IMG}/de0e5c948962fbf038cbac92f9e236e482eea7bcf934e69ce500c34bfe1e0b74.jpeg`,
    colors: ['#E0EEF5', '#4A8DB7', '#D4B483', '#2C4A5A', '#F5FAFF'],
    colorNames: ['Himmelblis', 'Ocean blue', 'Sand gold', 'Deep blue', 'Skumhvit'],
    fonts: { heading: 'Cormorant Garamond', body: 'Lora' },
    mood: 'Frisk, kyst, avslappet elegant',
  },
  {
    id: 'sage-olive', name: 'Sage & Olive', category: 'rustic',
    description: 'Deep sage and olive tones with gold foil details. Organic and earthy.',
    coverImage: `${IMG}/139453389440889ace4285524c89ec225d878e3ff627aa1472bb8cc42c44a9ef.jpeg`,
    colors: ['#E8EDE0', '#7A8B68', '#A0A878', '#D4AF37', '#F5F8F0'],
    colorNames: ['Light salvie', 'Sage', 'Oliven', 'Gold', 'Naturhvit'],
    fonts: { heading: 'Cormorant Garamond', body: 'Source Serif Pro' },
    mood: 'Natural, organic, earthy',
  },
  {
    id: 'dusty-blue', name: 'Dusty Blue', category: 'modern',
    description: 'Muted blue with silver accents. Sophisticated and calm as a quiet fjord.',
    coverImage: `${IMG}/b43a270f8fd3fd385940abee099f51af8bb914a348657a3169237c4a68734f11.jpeg`,
    colors: ['#E0E8F0', '#8BA4B8', '#C0C0C0', '#3A4550', '#F5F8FA'],
    colorNames: ['Ice blue', 'Dusty blue', 'Silver', 'Dark blue', 'Light blue'],
    fonts: { heading: 'Cormorant Garamond', body: 'Inter' },
    mood: 'Rolig, sofistikert, nordisk',
  },
  {
    id: 'burgundy-romance', name: 'Burgundy Romance', category: 'romantic',
    description: 'Deep burgunder med gulldetaljer. Rik, varm og dramatisk romantikk.',
    coverImage: `${IMG}/37f604b1cd55b341f043d364c6a08033216db9022426c242b0286d42a23cb591.jpeg`,
    colors: ['#2E0A16', '#8B2240', '#D4AF37', '#F5E8E0', '#1A0A10'],
    colorNames: ['Deep vin', 'Burgundy', 'Gold', 'Blush', 'Night dark'],
    fonts: { heading: 'Playfair Display', body: 'Cormorant Garamond' },
    mood: 'Dramatisk, varm, rik',
  },
  {
    id: 'autumn-wedding', name: 'Autumn Wedding', category: 'season',
    description: 'Burnt orange with golden leaves. The warmth and color splendor of autumn.',
    coverImage: `${IMG}/cf3752db58429d2eb47c63e362962bc292955928c4229c5db244ecc84230d1fb.jpeg`,
    colors: ['#F5E0C8', '#C87830', '#8B5E3C', '#D4A030', '#FFF5E8'],
    colorNames: ['Autumn light', 'Brent oransje', 'Rustbrun', 'Golden foliage', 'Cream'],
    fonts: { heading: 'Playfair Display', body: 'Lora' },
    mood: 'Warm, autumnal, cozy',
  },
  {
    id: 'winter-elegance', name: 'Winter Elegance', category: 'season',
    description: 'Ice white with silver snowflake details. Crystal clear winter elegance.',
    coverImage: `${IMG}/5867e6615b794695e13fcbebda0332a19ab958efc86a76836f6f86c06a8074d8.jpeg`,
    colors: ['#F0F5FA', '#C0D0E0', '#8090A0', '#2A3A4A', '#FFFFFF'],
    colorNames: ['Ice blue', 'Snow blue', 'Silver gray', 'Winter dark', 'Snow white'],
    fonts: { heading: 'Cormorant Garamond', body: 'Inter' },
    mood: 'Krystallklar, elegant, vinter',
  },
  {
    id: 'christmas-wedding', name: 'Christmas Wedding', category: 'season',
    description: 'Deep red velvet with gold and green holly. Magical Christmas wedding.',
    coverImage: `${IMG}/b69b599b50ae29c6eb15ba6e421330be16e45ac3d305f613f4ce4d03ff88a3c7.jpeg`,
    colors: ['#8B1A1A', '#D4AF37', '#2D5A27', '#F5E8E0', '#1A0A0A'],
    colorNames: ['Julering', 'Gold', 'Gran', 'Ivory', 'Deep red'],
    fonts: { heading: 'Playfair Display', body: 'Lora' },
    mood: 'Festlig, varm, magisk',
  },
  {
    id: 'boho-neutral', name: 'Boho Neutral', category: 'rustic',
    description: 'Varme beigetoner med pampagress og botaniske strektegninger. Avslappet boho-sjarm.',
    coverImage: `${IMG}/3b46c4dc3cce1c26bef0a916568409384658474b1eacde99c293ca50f2107eb3.jpeg`,
    colors: ['#F0E8D8', '#C8B090', '#A08060', '#5A4A38', '#FAF5EE'],
    colorNames: ['Beige', 'Sand', 'Kamel', 'Dark brown', 'Creamhvit'],
    fonts: { heading: 'Cormorant Garamond', body: 'Source Serif Pro' },
    mood: 'Avslappet, boho, naturlig',
  },
  {
    id: 'rustic-elegance', name: 'Rustic Elegance', category: 'rustic',
    description: 'Kraft paper with white calligraphy and wild flower sketches. Barn wedding with style.',
    coverImage: `${IMG}/ae022446212dfe76af3b2e2a03d490ba868eee7258122dde5763ca10fabfb664.jpeg`,
    colors: ['#C8A882', '#FFFFFF', '#8B7355', '#5A4A38', '#F0E8D8'],
    colorNames: ['Kraft', 'White', 'Naturtre', 'Dark bark', 'Light kraft'],
    fonts: { heading: 'Playfair Display', body: 'Source Serif Pro' },
    mood: 'Rustikk, sjarmerende, landlig',
  },
  {
    id: 'vintage-romance', name: 'Vintage Romance', category: 'romantic',
    description: 'Gammelrosa med vintageblonde og antikvitetsdetaljer. Nostalgisk romantikk.',
    coverImage: `${IMG}/1b4b72a3cff967f82f311fbad2289bacbcbfd8b5b11f05a3507624f1aaf0d0d2.jpeg`,
    colors: ['#F0D8D0', '#B07080', '#C8A890', '#4A3538', '#FFF0EE'],
    colorNames: ['Gammelrosa', 'Rosetre', 'Antikk gull', 'Deep plomme', 'Blush'],
    fonts: { heading: 'Playfair Display', body: 'Lora' },
    mood: 'Vintage, nostalgisk, romantisk',
  },
  {
    id: 'old-money', name: 'Old Money', category: 'classic',
    description: 'Hunter green with gold coat of arms and heraldic embossing. Aristocratic elegance.',
    coverImage: `${IMG}/68e92f3447934738e53d70a4038ab1cee8669a6658d3a1061d07a0ca4c88e34f.jpeg`,
    colors: ['#1A3A2A', '#D4AF37', '#8B7355', '#F5F0E8', '#0A2A1A'],
    colorNames: ['Hunter green', 'Gold', 'Bronse', 'Ivory', 'Dark green'],
    fonts: { heading: 'Cormorant Garamond', body: 'Lora' },
    mood: 'Aristocratic, classic, timeless',
  },
  {
    id: 'classic-white-green', name: 'Classic White & Green', category: 'classic',
    description: 'Fresh white with eucalyptus watercolor. Simple elegance inspired by green leaves.',
    coverImage: `${IMG}/09d85dfacd8104d58651df0b11920a43f6cd05e5967cc44a348ba8c047dc7493.jpeg`,
    colors: ['#FFFFFF', '#6B8F6B', '#A0C0A0', '#333333', '#F8FBF8'],
    colorNames: ['Ren hvit', 'Eukalyptus', 'Mint green', 'Charcoal', 'Naturhvit'],
    fonts: { heading: 'Cormorant Garamond', body: 'Inter' },
    mood: 'Frisk, ren, naturlig eleganse',
  },
  {
    id: 'soft-pastel', name: 'Soft Pastel', category: 'romantic',
    description: 'Delikate pastellregnbuefarger med akvarellblanding. Lett og eventyrlig.',
    coverImage: `${IMG}/780920807b257d913eec3340be4d1fc2be564613281d615b737231d1c0e8c8aa.jpeg`,
    colors: ['#F8E8F0', '#E0C8E8', '#C8E8D8', '#F0E8C0', '#FFF8FA'],
    colorNames: ['Rosa', 'Lavender', 'Mint', 'Gul', 'Creamrosa'],
    fonts: { heading: 'Playfair Display', body: 'Lora' },
    mood: 'Dreamy, soft, fairy-tale',
  },
  {
    id: 'mediterranean', name: 'Mediterranean', category: 'destination',
    description: 'Cobalt blue with white tile patterns and citrus accents. Greek island magic.',
    coverImage: `${IMG}/194d0f447be830f4c174752ad37b6ce337f34524cc8dca058fcb587579ca220d.jpeg`,
    colors: ['#1A4F8B', '#FFFFFF', '#F0C040', '#E07040', '#E0F0FF'],
    colorNames: ['Cobalt blue', 'White', 'Sitrongul', 'Terracotta', 'Himmelblis'],
    fonts: { heading: 'Cormorant Garamond', body: 'Source Serif Pro' },
    mood: 'Solrik, middelhavs, levende',
  },
  {
    id: 'destination-beach', name: 'Destination Beach', category: 'destination',
    description: 'Turkis hav med korall og sandgull tropiske blader. Beach Wedding i paradis.',
    coverImage: `${IMG}/0a368d786abfbc574bda8f282c4c8b439aece732f14001a61597597a25823602.jpeg`,
    colors: ['#40B0C0', '#FF8070', '#F0D080', '#1A5060', '#E0F8FA'],
    colorNames: ['Turkis', 'Coral', 'Sand gold', 'Deep hav', 'Seafoam'],
    fonts: { heading: 'Playfair Display', body: 'Lora' },
    mood: 'Tropisk, frisk, paradis',
  },
];

export const getThemeById = (id) => weddingThemes.find(t => t.id === id);
